import { render, staticRenderFns } from "./Dependent.vue?vue&type=template&id=6100ac70"
import script from "./Dependent.vue?vue&type=script&lang=ts"
export * from "./Dependent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports